import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicClinicRemodelling from "../Components/ProjPicClinicRemodelling";

const ProjectPageClinicRemodelling = () => {
    return (
        <>
            <Navbar />
            <ProjPicClinicRemodelling />
            <Footer />
        </>
    );
};

export default ProjectPageClinicRemodelling;
